// dom 操作相关
import { isIos, isWeb, isWeixinWeb, removeEmpty } from './util';
import { IconType, IOneIcon } from '../global.d';
import React, { CSSProperties, ReactNode} from 'react';
import {
  IComponent,
  IComponentContainerPadding,
  IComponentTab,
} from '../component';
import classNames from 'classnames';
import QrCode from 'qrcode';

//计算用来存在所有的弹出层悬浮等
export const getOuterDom = function (id: string, parentNode: HTMLElement) {
  let dom = window.document.getElementById(id);
  if (!dom) {
    dom = window.document.createElement('div');
    dom.id = id;
    parentNode.appendChild(dom);
  }

  return dom;
};

export const multiLine = (source:string, wrapper?:(str:string, index:number)=>ReactNode)=>{
  let array = (source || "").split('\n');
  return array.map((str:string, index:number)=>{
    if(wrapper) {
      return wrapper(str, index);
    }
    return <p key={index}>{str}</p>;
  });
};

//获取网页元素的绝对位置
export const getElementLeft = function (element: HTMLElement) {
  var actualLeft = element.offsetLeft;
  var current = element.offsetParent as HTMLElement | null;

  while (current !== null) {
    actualLeft += current.offsetLeft;
    current = current.offsetParent as HTMLElement;
  }

  return actualLeft;
};

export const getElementTop = function (
  element: HTMLElement,
  tillParent: Element | null = document.body
) {
  var actualTop = element.offsetTop;
  var current = element.offsetParent as HTMLElement;
  while (current !== null && current !== tillParent) {
    actualTop += current.offsetTop;
    current = current.offsetParent as HTMLElement;
  }
  //console.log(current,tillParent)

  return actualTop;
};
// 解决一个很奇葩的IOS的焦点问题，细节参考ReadMe
export const fixIosFocusProblem = function (e: HTMLElement) {
  // 这个诡异的代码请 参考ReadMe.md相关文档部分
  if (isIos()) {
    setTimeout(function () {
      // fixed IOS12
      document.body.scrollTop = document.body.scrollTop + 1;
      document.body.style.height = document.body.clientHeight + '';

      // fixed IOS13
      // 当所在容器是fixed的时候
      document.documentElement.scrollTop =
        document.documentElement.scrollTop + 1;
      // 正常容器
      if (e && e.scrollIntoView && typeof e.scrollIntoView == 'function') {
        e.scrollIntoView();
      }
    }, 16);
  }
};

export function renderImg({ type, className, icon }: IOneIcon) {
  return type === IconType.span ? (
    <span className={className} />
  ) : (
    <img src={icon} alt={''} className={'icon'} />
  );
}

// 用于处理api v2的情况，注意，对应的css请加上.old，细节请参考一下actinfo等
export const getCompatibleCls = function (cls: string, api?: string) {
  return classNames(cls, { old: api !== 'v2' });
};
export const shouldRenderBgColor = function (component: IComponent) {
  const { type } = component;
  const noBgType = [
    'formocr',
    'tips',
    'navigator',
    'multi_video',
    'hot',
    'hot_pic',
    'buttongroup',
  ];
  // 以上都不渲染背景色
  if (noBgType.includes(type)) {
    return false;
  }
  // 特殊情况
  const { mode } = component as IComponentTab;
  if (type === 'tab' && mode === 'left') {
    return false;
  }
  return true;
};

export const setDefaultPadding = function (
  component: IComponent
): IComponentContainerPadding {
  const { container, type } = component;
  const { paddingBottom, paddingLeft, paddingRight, paddingTop } = container;
  const defaultPadding = {
    paddingBottom: 10,
    paddingLeft: 15,
    paddingRight: 15,
    paddingTop: 10,
  };
  // 如果有值，不需要做任何处理
  if (
    [paddingBottom, paddingLeft, paddingRight, paddingTop].every(
      (one) => one === undefined
    )
  ) {
    if (type === 'hvideolist') {
      return defaultPadding;
    }
  }
  return {
    paddingBottom: paddingBottom ? +paddingBottom : undefined, // null/undefined都会被干掉
    paddingLeft: paddingLeft ? +paddingLeft : undefined,
    paddingRight: paddingRight ? +paddingRight : undefined,
    paddingTop: paddingTop ? +paddingTop : undefined,
  };
};

export const setContainer = (
  component: IComponent,
  componentColor: string
): CSSProperties => {
  const { container } = component;
  if (!container) {
    return {};
  }
  const {
    // 遇到了NaN的情况，估计是有值undefined了
    left = 0,
    top = 0,
    bottom = 0,
    right = 0,
    borderRadius,
    useThemeColor,
    componentBg,
  } = container;
  const should = shouldRenderBgColor(component);
  // 优先使用componentBg，如果useThemeColor 存在且为false
  const setBg = function () {
    if (useThemeColor === false) {
      return componentBg;
    }
    // true undefined
    return useThemeColor || should ? componentColor : null;
  };
  const setRadius = function () {
    if (borderRadius === undefined) {
      return null;
    }
    // isNaN的情况类似4px/ 4px 3px 等， 如果传入的是纯数字，那么转成数字即可
    return Number.isNaN(+borderRadius) ? borderRadius : +borderRadius;
  };
  const backgroundColor = setBg();
  const radius = setRadius();
  const padding = setDefaultPadding(component);
  return removeEmpty(
    {
      marginLeft: +left,
      marginTop: +top,
      marginBottom: +bottom ? +bottom : 0,
      marginRight: +right,
      ...padding,
      borderRadius: radius,
      backgroundColor,
      position: component.type == 'empty' ? 'relative' : undefined,
    },
    { number0: false }
  );
};

const webkitFullScreenWebkit = () => {
  if (typeof window.document.fullscreenElement != 'undefined') {
    return window.document.fullscreenElement;
  }
  if (typeof window.document.webkitFullscreenElement != 'undefined') {
    return window.document.webkitFullscreenElement;
  }
  // const result = document.fullscreenEnabled ||
  // // @ts-ignore
  // window.fullScreen ||
  // // @ts-ignore
  // document.mozFullscreenEnabled ||
  // // @ts-ignore
  // document.webkitIsFullScreen;
  return;
};

export const isFullScreen = function () {
  // const isFullscreen =
  //   document.fullscreenEnabled ||
  //   // @ts-ignore
  //   window.fullScreen ||
  //   // @ts-ignore
  //   document.mozFullscreenEnabled ||
  //   // @ts-ignore
  //   document.webkitIsFullScreen;
  // return isFullscreen;
  // 参考https://developer.mozilla.org/zh-CN/docs/Web/API/Fullscreen_API/%E6%8C%87%E5%8D%97
  // 只有PC需要考虑全屏的问题

  // weixin web浏览器下会被默认是全屏的，所以这里排除掉
  let flag = isWeb() && !isWeixinWeb() && webkitFullScreenWebkit() !== null;
  if (isWeixinWeb()) {
    // 微信桌面浏览器下，只有webkitIsFullScreen在生效
    // @ts-ignore
    flag = window.document.webkitIsFullScreen;
  }
  return flag;
};

export const requestFullScreen = function (element?: Element) {
  element = element || document.documentElement;
  const requestMethod =
    element.requestFullscreen || //W3C
    // @ts-ignore
    element.webkitRequestFullScreen || //Chrome等
    // @ts-ignore
    element.mozRequestFullScreen || //FireFox
    // @ts-ignore
    element.msRequestFullScreen; //IE11
  if (requestMethod) {
    requestMethod.call(element);
  } else if (typeof window.ActiveXObject !== 'undefined') {
    //for Internet Explorer
    const wscript = new window.ActiveXObject('WScript.Shell');
    if (wscript !== null) {
      wscript.SendKeys('{F11}');
    }
  }
};

export const pushHistory = (target: string) => {
  if (window.history) {
    window.history.pushState(
      window.history.state,
      Date.now() + '',
      window.location.href + '#' + target
    );
  }
};

export const backHistory = (target: string) => {
  if (window.history) {
    if (window.location.hash && window.location.hash.indexOf('target') >= 0) {
      window.history.go(-1);
    }
  }
};

export const qrcodePayDialog = async (
  url: string,
  callback: (status: string) => void,
  options?: any
) => {
  var container = document.createElement('div');
  container.className = 'qrcode-pay';
  container.setAttribute('id', 'qrcode-pay');
  var content = document.createElement('div');
  content.className = 'content';

  let qrcodeURL = await QrCode.toDataURL(url);

  content.innerHTML = `
    <a class="close"><img src="${require('../assets/x-20.png')}" /></a>
    <div class="title">
     ${options && options.mainTitle ? options.mainTitle : '请扫码支付'}
    </div>
    <div id="qrcode">
      <img src="${qrcodeURL}" />
    </div>
    <div class="pay-button">已支付完成</div>
  `;

  container.appendChild(content);

  let close = content.querySelector('.close');
  if (close) {
    // @ts-ignore
    close.onclick = function () {
      document.body.removeChild(container);
      callback('fail');
    };
  }

  let done = content.querySelector('.pay-button');
  if (done) {
    // @ts-ignore
    done.onclick = function () {
      document.body.removeChild(container);
      callback('check');
    };
  }

  document.body.appendChild(container);
};

export const weixinLoginDialog = (
  session: string,
  redirect: string,
  hideClose: boolean = false,
  webAppId: string = 'wxea67ba2c7e2c3362'
) => {
  var container = document.createElement('div');
  container.className = 'weixin-login';
  container.setAttribute('id', 'weixin-login');
  var content = document.createElement('div');
  content.className = 'content';

  let locale = 'zh-CN';

  const renderContent = () => {
    return `<div class="title">
      <img src="data:image/png;base64,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" />
      <span>${locale == 'zh-CN' ? '微信扫码登录' : 'Log in via WeChat'}</span>
    </div>
    <div class="desc">
      <p>${
        locale == 'zh-CN'
          ? '申请获得你的公开信息（昵称、头像等）'
          : 'Obtain your public infomation<br/>(Name, Profile Photo)'
      }</p>
      <p>${locale == 'zh-CN' ? '该功能需微信扫码登录才可使用，请扫描下方二维码' : 'This function requires wechat scan code login to use, please scan the QR code below'}</p>
    </div>`;
  };

  content.innerHTML = `
    ${
      hideClose
        ? ''
        : `<a class="close"><img src="${require('../assets/x-20.png')}" /></a>`
    }
    <div class="title-dom" id="weixin-title-dom">
    </div>
    <div id="qrcode" style="height:${
      locale == 'zh-CN' ? '200px' : '200px'
    }"></div>
    <div class="locale-change" id="weixin-locale">${
      locale == 'zh-CN' ? 'EN' : '中文'
    }</div>
  `;

  container.appendChild(content);

  let title = content.querySelector('#weixin-title-dom');
  if (title) {
    title.innerHTML = renderContent();
  }

  let close = content.querySelector('.close');
  if (close) {
    // @ts-ignore
    close.onclick = function () {
      document.body.removeChild(container);
    };
  }

  let localeDom = content.querySelector('#weixin-locale');
  if (localeDom) {
    localeDom.addEventListener('click', () => {
      if (localeDom) {
        if (locale == 'zh-CN') {
          locale = 'en-US';
          localeDom.innerHTML = '中文';
        } else {
          locale = 'zh-CN';
          localeDom.innerHTML = 'EN';
        }
      }

      if (title) {
        title.innerHTML = renderContent();
      }
    });
  }

  document.body.appendChild(container);

  setTimeout(() => {
    var obj = new window.WxLogin({
      self_redirect: false,
      id: 'qrcode',
      appid: webAppId,
      scope: 'snsapi_login',
      redirect_uri: encodeURIComponent(redirect),
      state: session + '_weixin_login',
      style: 'black',
      href: '//image1' + window.__basename + '/static/weixin.qrcode.v3.css?v=2',
    });
  }, 160);
};
